import ActionType from './ActionType';

export function reset() {
  return {type: ActionType.RESET};
}

export function signIn(token, user) {
  return {type: ActionType.SIGN_IN, token, user};
}

export function setUser(user) {
  return {type: ActionType.SET_USER, user};
}

export function updateSetting(user, key, value) {
  return {type: ActionType.UPDATE_SETTING, user, key, value};
}

export function updateNotificationCount(count) {
  return {type: ActionType.UPDATE_NOTIFICATION_COUNT, count};
}

export function updateCompanySettings(labels) {
  return {type: ActionType.UPDATE_COMPANY_SETTINGS, labels};
}

export function updateCompanyLogo(logo) {
  return {type: ActionType.UPDATE_COMPANY_LOGO, logo};
}